import { render, staticRenderFns } from "./yqg-title.vue?vue&type=template&id=122eab74&"
import script from "./yqg-title.vue?vue&type=script&lang=js&"
export * from "./yqg-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('122eab74')) {
      api.createRecord('122eab74', component.options)
    } else {
      api.reload('122eab74', component.options)
    }
    module.hot.accept("./yqg-title.vue?vue&type=template&id=122eab74&", function () {
      api.rerender('122eab74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/vue/component/yqg-title/yqg-title.vue"
export default component.exports